import { TeamMember } from '../types'

export const teamMembers: TeamMember[] = [
  // Team Members from PPT in exact order
  {
    id: '1',
    name: 'Mr. Mustafa Kamruddin Ariwala',
    position: 'CEO / Partner',
    image: '/images/team/team-member-1.jpg',
    description: 'Leading the company with strategic vision and extensive experience in construction management.'
  },
  {
    id: '2',
    name: 'Mr. Karthikeyan Paramanandam',
    position: 'Managing Director',
    image: '/images/team/team-member-4.jpg',
    description: 'Overseeing daily operations and ensuring project delivery excellence across all divisions.'
  },
  {
    id: '3',
    name: 'Mr. Saif Eid Saif Beljafla Almansoori',
    position: 'Sponsored & Investor',
    image: '/images/team/team-member-5.jpg',
    description: 'Providing technical expertise and ensuring construction specifications are met.'
  },
  {
    id: '4',
    name: 'Mr. Benedict Prabhakaran',
    position: 'Senior Project Manager',
    image: '/images/team/team-member-2.jpg',
    description: 'Managing complex construction projects with expertise in planning and execution.'
  },
  {
    id: '5',
    name: 'Mr. Krishna Kumar',
    position: 'Senior Project Manager',
    image: '/images/team/team-member-3.jpg',
    description: 'Supervising construction activities and ensuring quality standards on site.'
  },
  {
    id: '6',
    name: 'Mr. Jagadeesh Subbannan',
    position: 'Civil Estimation Manager',
    image: '/images/team/team-member-6.jpg',
    description: 'Specialized in mechanical, electrical, and plumbing systems design and implementation.'
  },
  {
    id: '7',
    name: 'Mr. Sivaraman Sivalingam',
    position: 'MEP Engineer',
    image: '/images/team/team-member-7.jpg',
    description: 'Ensuring quality standards and compliance with construction regulations.'
  },
  {
    id: '8',
    name: 'Mr. Sabari Rajan Neethiselvam',
    position: 'Senior Civil Engineer',
    image: '/images/team/team-member-8.jpg',
    description: 'Designing and supervising civil engineering projects and infrastructure.'
  },
  {
    id: '9',
    name: 'Mr. Rajesh Moorthy',
    position: 'Civil Engineer',
    image: '/images/team/team-member-11.jpg',
    description: 'Implementing safety protocols and ensuring workplace safety compliance.'
  },
  {
    id: '10',
    name: 'Mr. Siva Sivalingam',
    position: 'Electrical Engineer',
    image: '/images/team/team-member-9.jpg',
    description: 'Leading construction teams and coordinating daily site activities.'
  },
  {
    id: '11',
    name: 'Mr. Prashanth Muthupandi',
    position: 'Electrical Engineer',
    image: '/images/team/team-member-10.jpg',
    description: 'Managing procurement processes and supplier relationships for construction materials.'
  },
  {
    id: '12',
    name: 'Mr. Pandiyan Murugan',
    position: 'Civil Procurement Coordinator',
    image: '/images/team/team-member-12.jpg',
    description: 'Coordinating civil procurement activities and managing material supply chains.'
  },
  {
    id: '13',
    name: 'Ms. Kiruthika Murthi',
    position: 'MEP Procurement Coordinator',
    image: '/images/team/team-member-13.jpg',
    description: 'Specialized in MEP procurement coordination with extensive knowledge in mechanical, electrical, and plumbing systems.'
  },
  {
    id: '14',
    name: 'Ms. Nandhini Kanthasamy',
    position: 'Accountant',
    image: '/images/team/team-member-14.jpg',
    description: 'Handling financial management, accounting operations, and financial reporting.'
  },
  {
    id: '15',
    name: 'Ms. Padmavathy M',
    position: 'HR & Admin',
    image: '/images/team/team-member-15.jpg',
    description: 'Managing human resources and administrative functions for smooth company operations.'
  }
]
